(() => {
  const applyHeight = (slider, swiper) => {
    const defaultHeight = slider.dataset.defaultHeight;
    const activeSlide = swiper.slides[swiper.activeIndex];
    const overrideHeight = activeSlide && activeSlide.dataset.slideHeight;
    const height = overrideHeight || defaultHeight;

    Array.from(slider.classList).forEach((className) => {
      if (className.indexOf('lc-slideshow--') === 0) {
        slider.classList.remove(className);
      }
    });

    slider.classList.add(`lc-slideshow--${height}`);

    if (height === 'adapt' && activeSlide) {
      slider.style.setProperty('--lc-active-aspect-desktop', activeSlide.dataset.aspectDesktop);
      slider.style.setProperty('--lc-active-aspect-mobile', activeSlide.dataset.aspectMobile);
    }
  };

  const applyScheme = (slider, swiper) => {
    const pagination = slider.querySelector('.lc-slider__pagination');
    if (!pagination) return;
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;
    const scheme = Array.from(activeSlide.classList).find((className) => className.indexOf('color-scheme') === 0);
    if (!scheme) return;

    Array.from(pagination.classList).forEach((className) => {
      if (className.indexOf('color-scheme') === 0) {
        pagination.classList.remove(className);
      }
    });

    pagination.classList.add(scheme);
  };

  const wire = (slider) => {
    if (slider.dataset.lcHeightWired) return;
    slider.dataset.lcHeightWired = 'true';
    slider.addEventListener('lc-slider:init', (e) => {
      applyHeight(slider, e.detail.swiper);
      applyScheme(slider, e.detail.swiper);
    });
    slider.addEventListener('lc-slider:slidechange', (e) => {
      applyHeight(slider, e.detail.swiper);
      applyScheme(slider, e.detail.swiper);
    });
  };

  document.querySelectorAll('.lc-slideshow[data-default-height]').forEach(wire);

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.lc-slideshow[data-default-height]').forEach(wire);
  });
})();
